import gold_border from './gold.jpg';
import gray_temp_img from './gray-temp-img.jpg';

export const imgs = {
  gold_border,
  gray_temp_img,
};
